export default "__VITE_ASSET__OGEVMsUy__"